const fontWeight = {
    name: "font-weight",
    path: "/font-weight",
    title: "font-weight",
    description: "Utilities for controlling the font weight of text.",
    value: {
        "font-weight": {
            "font-thin": "100",
            "font-extralight": "200",
            "font-light": "300",
            "font-normal": "400",
            "font-medium": "500",
            "font-semibold": "600",
            "font-bold": "700",
            "font-extrabold": "800",
            "font-black": "900",
            "font-[<value>]": "<value>"
        }
    },
    exampleData: [
        {
            example: {
                code: `
<p class="font-thin text-lg">The quick brown fox jumps over the lazy dog. (font-thin)</p>
<p class="font-extralight text-lg">The quick brown fox jumps over the lazy dog. (font-extralight)</p>
<p class="font-light text-lg">The quick brown fox jumps over the lazy dog. (font-light)</p>
<p class="font-normal text-lg">The quick brown fox jumps over the lazy dog. (font-normal)</p>
<p class="font-medium text-lg">The quick brown fox jumps over the lazy dog. (font-medium)</p>
<p class="font-semibold text-lg">The quick brown fox jumps over the lazy dog. (font-semibold)</p>
<p class="font-bold text-lg">The quick brown fox jumps over the lazy dog. (font-bold)</p>
<p class="font-extrabold text-lg">The quick brown fox jumps over the lazy dog. (font-extrabold)</p>
<p class="font-black text-lg">The quick brown fox jumps over the lazy dog. (font-black)</p>
        `
            }
        },
        {
            example: {
                code: `
<p class="font-[1000] ...">
  Lorem ipsum dolor sit amet...
</p>
        `
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">font-light</code> through <code class="text-color-gray-800 dark:text-color-white font-semibold">font-black</code> to control the font weight:
      </p>
      <div class="space-y-6">
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-light</small>
            <p class="font-light text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-normal</small>
            <p class="font-normal text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-medium</small>
            <p class="font-medium text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-semibold</small>
            <p class="font-semibold text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-bold</small>
            <p class="font-bold text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-extrabold</small>
            <p class="font-extrabold text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
        },
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">font-[<value>]</code> syntax to set the font weight based on a completely custom value:
      </p>
      `
        }
    ]
}
export default fontWeight;
<div className="font-light font-normal font-medium font-semibold font-bold font-extrabold font-black text-lg"></div>